import store from '../../store/index'
import moment from 'moment'

const state = store.state
const img_req_url = state.img_req_url

const filter = {
  empty(v, x = '--') { // 剔除空值的情况
    return v ? v : x
  },
  deal(p, dir, w = 'name') { // 基本过滤,w表示返回字段,dir表示用哪一个字典(为字符串)
    if (!state[dir]) {
      return '--'
    }
    let i = state[dir].findIndex((item) => item.id == p)
    if (p + '' && i != -1) {
      return state[dir][i][w]
    } else {
      return '--'
    }
  },
  dealNeed(p, dir, w = 'name', n = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典(为数组)
    let i = dir.findIndex((item) => item.id == p)
    if (p + '' && i != -1) {
      return dir[i][w]
    } else {
      return n
    }
  },
  time_deal(t, format = 'YYYY-MM-DD') { //时间转化格式
    if (t) {
      return t == '0000-00-00 00:00:00' || t == '0000-00-00' ? '--' : moment(t).format(format)
    }
    else {
      return '--'
    }
  },
  logo(path, pic_name = 'default-peo-logo') { // 图片
    if (path) {
      return img_req_url + path
    } else {
      // return require(`../img/${pic_name}.png`)
      return ''
    }
  },
  get_logo(path) {
    return require('../img/' + path)
  },
  toPercentage(num, r = 0) { //百分数
    if (num) {
      if(parseFloat(num)) {
        return Math.round(parseFloat(num) * 100) / 100 + '%'
      } else {
        return '--'
      }
    } else {
      return r
    }
  },
  toPercentage2(num, r = 0) { //小数转百分数
    if (num) {
      return Math.round(num * 10000) / 100 + '%'
    } else {
      return r
    }
  },
  toPercentage3(num, r = 0) { //保留两位小数
    if (num) {
      return Math.round(num * 100) / 100
    } else {
      return r
    }
  }
}
export default filter